import React from 'react';
import CustomModal from "../../../../components/Modal/CustomModal";
import {ChooseAFormModalApp} from "../Functionality/EntryAndExitForms/ChooseAFormModalApp";
import {ENTRY_AND_EXIT_FORMS} from "../Model/Model";
import routes from "../../../../Routes/routes";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const ChooseAFormModal = (props) => {
    const { onHide, show } = props;

    const {
        t,
        navigate,
        handleClearFields,
        formSelected,
        handleSelectForm
    } = ChooseAFormModalApp();

    return (
        <CustomModal
            title={'choose_a_form'}
            show={show}
            size='lg'
            buttonConfirm='confirm'
            onHide={() => {
                handleClearFields();
                onHide();
            }}
            confirmButton={true}
            cancelButton={true}
            disabled={!formSelected}
            onConfirm={() =>  navigate(routes.entryAndExitForms.create, { state: { formKey: formSelected?.key }})}
        >
            <div className={"row"}>
                { Object.values(ENTRY_AND_EXIT_FORMS).map(e => <div className={"col-12 mb-3"} key={e.index}>
                    <div
                        className={`d-flex border-radius-8px p-3 cursor-pointer ${formSelected?.index === e.index ? "border-full-secondary-400 background-secondary-50" : "border-full-shades-100 background-shades-50"}`}
                        onClick={() => handleSelectForm(e)}
                    >
                        <div className={"background-secondary-100 align-items-center justify-content-center p-3 border-radius-8px mr-3"}>{<e.Icon/>}</div>
                        <div>
                            <p className={"fs-14px ibl-font-w-600"}>{t(e.trans)}</p>
                            <p className={"fs-14px"}>{t(e.description)}</p>
                        </div>
                    </div>
                </div>)
                }
            </div>
        </CustomModal>
    );
};

export default ChooseAFormModal;
